import log from "loglevel";

import { getMdmData as getMatchData } from "../../../utils/api/errorSuppressionApi";
import { getMonitoringPlans } from "../../../utils/api/monitoringPlansApi";
import { DatabaseContext } from "../../../utils/constants/databaseContext";

// The mdm api returns a data that looks different for each Data Type Code.
// The below function maps the correct description and code field for a
// Data Type Code
export const getMatchDataFieldNames = (dataTypeCode) => {
  let descriptionField;
  let codeField;

  switch (dataTypeCode) {
    case "CEPARAM":
      descriptionField = "controlEquipParamDescription";
      codeField = "controlEquipParamCode";
      break;
    case "COMPTYP":
      descriptionField = "componentTypeDescription";
      codeField = "componentTypeCode";
      break;
    case "FUELTYP":
      descriptionField = "fuelTypeDescription";
      codeField = "fuelTypeCode";
      break;
    case "PROGRAM":
      descriptionField = "programDescription";
      codeField = "programCode";
      break;
    case "QUALTYP":
      descriptionField = "qualificationTypeDescription";
      codeField = "qualificationTypeCode";
      break;
    case "SYSTYP":
      descriptionField = "systemTypeDescription";
      codeField = "systemTypeCode";
      break;
    case "TESTTYP":
      descriptionField = "testTypeDescription";
      codeField = "testTypeCode";
      break;
    case "MATSPAR":
      descriptionField = "matsMethodParameterDescription";
      codeField = "matsMethodParameterCode";
      break;
    case "PARAM":
      descriptionField = "parameterDescription";
      codeField = "parameterCode";
      break;
    case "MONPLAN":
      descriptionField = "labelName";
      codeField = "id";
      break;
    case "TESTNUM":
      descriptionField = "testNumber";
      codeField = "testNumber";
      break;

    default:
      break;
  }

  return [codeField, descriptionField];
};

// Returns an array of objects which are used in the jsx to construct the match data type dropdowns.
// The shape of the return looks like: [{"label":"option text", "value":"option value"},...]
export const createMatchTypeDropdownLists = async (
  checkCatalogResult,
  orisCode,
) => {
  const { dataTypeCode, dataTypeUrl, checkTypeCode, checkNumber } =
    checkCatalogResult;

  // sanity check
  if (
    !checkCatalogResult ||
    !dataTypeUrl ||
    !dataTypeCode ||
    !checkTypeCode ||
    !checkNumber
  ) {
    return [];
  }

  // TESTNUM won't have any match type dropdown
  if (dataTypeCode === "TESTNUM") {
    return [];
  }

  const [codeField, descriptionField] = getMatchDataFieldNames(dataTypeCode);
  // sanity check
  if (!codeField || !descriptionField) return [];

  const processPromiseData = (data) => {
    if (!data || !data.items ) return [];

    let dataToProcess = data.items;

    // SPECIAL CASE - see case for PARAM in ticket 4621
    if (dataTypeCode === "PARAM") {
      dataToProcess = dataToProcess.filter(
        (d) =>
          d.checkTypeCode === checkTypeCode && d.checkNumber === checkNumber
      );
    }

    if (dataTypeCode === "MONPLAN") { 
      dataToProcess = dataToProcess.map((d) => {
        const reportPeriodRange =
          d.endReportPeriodId === null
            ? ""
            : ` (${d.beginReportPeriodDescription} - ${d.endReportPeriodDescription})`;
  
        return {
          ...d,
          labelName: `ORIS ${d.orisCode}, ${d.name}${reportPeriodRange}`,
        };
      });
    }

    // The following creates a unique list of objects so something like [{label:1, value:1}, {label:1, value:1}] would become [{label:1, value:1}]
    const objStrList = dataToProcess
      .map((d) => ({
        label: d[descriptionField],
        value: d[codeField],
      }))
      .map((r) => JSON.stringify(r));

    return Array.from(new Set(objStrList)).map((r) => JSON.parse(r));
  };

  // SPECIAL CASE - see case for MONPLAN in ticket 4621
  if (dataTypeCode === "MONPLAN") {
    const orisCodes = orisCode ? [orisCode]:[];

    try {
      const { data } = await getMonitoringPlans(orisCodes, [], DatabaseContext.WORKSPACE);
      const returnData = processPromiseData(data);
      return returnData;
    } catch (e) {
      log.error(e);
      return [];
    }
  }
  else {
    const path = dataTypeUrl.split("/").slice(2).join();

    try {
      const { data } = await getMatchData(path);
      return processPromiseData(data);
    } catch (e) {
      log.error(e);
      return [];
    }
  }

};

export const convertYearQuarterToDateString = (yearQuarter) => {
  const [year, quarter] = yearQuarter.split(' ');
  let result;

  switch (quarter) {
    case ('Q1'):
      result = new Date(`${year}/01/01`);
      break;
    case ('Q2'):
      result = new Date(`${year}/04/01`);
      break;
    case ('Q3'):
      result = new Date(`${year}/07/01`);
      break;
    case ('Q4'):
      result = new Date(`${year}/10/01`);
      break;
    default:
  }

  if( !result )
    return null;

  return result.toISOString();
}
